import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import { useRoute } from 'vue-router/composables'
  import useCourse from '@/composables/useCourse'
  import useEditor from '@/composables/useEditor'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'

  import { CourseModule } from '@/store/modules/course'
  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BookmarkLesson',
  props: {
    canEdit: {
      default: true,
      type: Boolean,
    },
    lessonModuleId: String,
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const { inEditorMode: editorMode } = useEditor(route)
  const { bookmarkCourseLesson, unBookmarkCourseLesson, courseLessonIsBookmarked, course, currentLesson } = useCourse()
  const { bookmarkInactive } = useIcons()
  const { isMobileDevice } = useBreakpoint()

  const hovering = ref(false)

  const inEditorMode = computed(() => editorMode.value && props.canEdit)

  const isBookmarked = computed(() => {
    return courseLessonIsBookmarked.value(currentLesson.value!.id)
  })

  const bookmarkIconStrokeColor = computed(() => {
    return isBookmarked.value ? 'var(--primary-color)' : 'var(--primary-text-color)'
  })

  const courseModule = computed(() => {
    return CourseModule.lessonModule(course.value!.id, currentLesson.value!.id)
  })

  const hasBookmarkedALesson = computed(() => {
    return UserModule.getStartedChecklist?.bookmarkLesson
  })

  const hoveringBookmark = (hovered: boolean) => {
    if (!inEditorMode.value && !isMobileDevice.value) {
      hovering.value = hovered
    }
  }

  const bookmarkLesson = () => {
    if (isBookmarked.value) {
      unBookmarkCourseLesson(
        course.value!.id,
        course.value!.title,
        courseModule.value!.id,
        courseModule.value!.name,
        currentLesson.value!.id,
        currentLesson.value!.title,
      )
    } else {
      bookmarkCourseLesson(
        course.value!.id,
        course.value!.title,
        courseModule.value!.id,
        courseModule.value!.name,
        currentLesson.value!.id,
        currentLesson.value!.title,
      )

      if (!hasBookmarkedALesson.value) {
        UserModule.setGetStartedChecklistItem({ item: 'bookmarkLesson', value: true })
      }
    }
  }

return { __sfc: true,props, route, editorMode, bookmarkCourseLesson, unBookmarkCourseLesson, courseLessonIsBookmarked, course, currentLesson, bookmarkInactive, isMobileDevice, hovering, inEditorMode, isBookmarked, bookmarkIconStrokeColor, courseModule, hasBookmarkedALesson, hoveringBookmark, bookmarkLesson, computed, ref, SVGRenderer, useRoute, useCourse, useEditor, useIcons, useBreakpoint, CourseModule, UserModule }
}

})